import script from "./NewsInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsInformation.vue?vue&type=script&setup=true&lang=js"

import "./NewsInformation.vue?vue&type=style&index=0&id=4f15d96a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f15d96a"]])

export default __exports__